import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as IconPreApproved } from 'style/icons/icon-preapproved.svg';
import Label from 'components/form/Label/Label';
import { Link } from 'components/navigation/Link/Link';

const MarketplacePreApprovedBannerView = props => {
  const { onLinkClick, seenPixel, bannerTitle } = props;
  const link = (
    <Link
      to="/offers/creditcard?creditCardType=MORE_CARDS"
      className="link text-14 pad bold m-margT8"
      onClickCallback={onLinkClick}
    >
      See your offers
    </Link>
  );

  return (
    <>
      {seenPixel}
      <SectionContainer
        padding="padTB20 padLR32 m-padLR16"
        margin="margT20 margB32"
      >
        <FlexContainer
          alignItemsCenter
          justifyBetween
          className="m-block m-text-center"
        >
          <IconPreApproved className="desktopHide" />
          <FlexContainer alignItemsCenter className={'m-margT8'}>
            <IconPreApproved className="mobileHide" />
            <Label type="Body-1" className="margL16">
              {bannerTitle}
            </Label>
          </FlexContainer>
          <FlexContainer className="mobileHide">{link}</FlexContainer>
          <FlexContainer className="desktopHide">{link}</FlexContainer>
        </FlexContainer>
      </SectionContainer>
    </>
  );
};

export default MarketplacePreApprovedBannerView;
